// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo___f9p72","sider":"sider___huB6V","icon":"icon___V4qRG"};